import { t } from 'ttag';

import { Button } from '@ui/Button';
import Title from '@ui/Title';
import { FadeIn } from '@ui/Animations/FadeIn';

import SvgGirl from './images/sad-error.svg';

import s from './StubForError.sss';

export const StubForError: React.FC = () => (
  <div className={s.wrapper}>
    <FadeIn className={s.root}>
      <img className={s.girlIcon} src={SvgGirl} alt="Something went wrong" />
      <Title className={s.title} type="h3" bold={false}>
        {t`Ой, щось пішло не так`}
      </Title>
      <p>{t`Повторіть спробу пізніше`}</p>
      <div className={s.buttonsBlock}>
        <Button
          className={s.addNewProductButton}
          href="/"
          theme="secondary"
        >
          {t`Добре`}
        </Button>
      </div>
    </FadeIn>
  </div>
);

export default StubForError;
